export default function runRhinoRun($log) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let rhinoVersion = 'unknown';
  /* global __RHINO_VERSION__ */
  if (typeof __RHINO_VERSION__ !== 'undefined') {
    rhinoVersion = __RHINO_VERSION__;
  }
  $log.info(
" __   __         ___  __   __  \n" +
"|__) |__) | |\\ |  |  /  \\ /__` \n" +
"|    |  \\ | | \\|  |  \\__/ .__/ \n");

  $log.info('Rhino version: ' + rhinoVersion);
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/core/core.run.js